module.exports = __webpack_public_path__ + "img/hacienda-room-4.a8738dd3.jpg";